const ReadableCardBrand = Object.freeze({
  'visa': 'Visa',
  'mastercard': 'MasterCard',
  'amex': 'American Express',
})

export default ReadableCardBrand